import React from 'react';
import "./solutions_view.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import TitlePage from "../../../core/components/title_pages/title_pages.jsx";
import SoluctionsCards from "../../../core/components/cards/soluctions_card/soluctions_card.jsx";
import { solutionsMapper } from "../utils/mapper/solutions_mapper.jsx";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";

const SolutionsView = () => {
    const swiperRef = React.useRef(null);
    const { title, sectionTitle, cards, swiperConfig } = solutionsMapper;

    return (
        <div className="solutions">
            <div className="container">
                <TitlePage title={title} />
                <div className='row'>
                    <div className="col-6 soluctions_title">
                        <h1>{sectionTitle.split('\n').map((line, i) => (
                            <React.Fragment key={i}>{line}{i < 2 && <br />}</React.Fragment>
                        ))}</h1>
                    </div>
                    <div className="col-6 button_controller_carousel_container">
                        <div
                            onClick={() => swiperRef.current?.slidePrev()}
                            className="custom-arrow left-arrow button_controller_carousel"
                        >
                            <FaChevronLeft />
                        </div>
                        <div
                            onClick={() => swiperRef.current?.slideNext()}
                            className="custom-arrow right-arrow button_controller_carousel"
                        >
                            <FaChevronRight />
                        </div>
                    </div>
                </div>
            </div>
            <div className="soluctions_cards carousel-no-select">
                <Swiper
                    modules={[Navigation, Keyboard]}
                    onSwiper={(swiper) => { swiperRef.current = swiper }}
                    spaceBetween={swiperConfig.spaceBetween}
                    slidesPerView={swiperConfig.slidesPerView}
                    slidesPerGroup={swiperConfig.slidesPerGroup}
                    speed={swiperConfig.speed}
                    keyboard={{ enabled: true }}
                    breakpoints={swiperConfig.breakpoints}
                    className="swiper-container"
                >
                    {cards.map((card) => (
                        <SwiperSlide key={card.id}>
                            <SoluctionsCards
                                title_front={card.title_front}
                                description_front={card.description_front}
                                image={card.image}
                                title_back={card.title_back}
                                description_back={card.description_back}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default SolutionsView;
